import { styled } from '@mui/material';

export const getButtonStyles = (theme, variant) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  width: 'fit-content',
  fontWeight: '500',
  borderRadius: '120px',
  color:
    variant === 'secondary'
      ? theme.palette.color.fg.inversePrimary
      : theme.palette.color.fg.primary,
});

export const Button = styled('button', {
  shouldForwardProp: (prop) => prop !== 'variant',
})(({ theme, variant }) => ({
  ...getButtonStyles(theme, variant),
  height: '50px',
  fontSize: '16px',
  border: 'none',
  cursor: 'pointer',
  outline: 'none',
  transition: 'all 0.2s ease-in-out',
  willChange: 'transform',
  backgroundColor:
    variant === 'secondary'
      ? theme.palette.color.button.primaryDefault
      : theme.palette.color.surface.modalTetriary,

  '&:hover': {
    backgroundColor:
      variant === 'secondary'
        ? theme.palette.color.button.primaryHover
        : theme.palette.color.surface.modalTetriaryHover,
  },
  '&:active': {
    transform: 'scale(0.95)',
  },

  [theme.breakpoints.down('2xl')]: {
    height: '44px',
    fontSize: '14px',
  },
  [theme.breakpoints.down('lg')]: {
    height: '40px',
  },
}));
